import { Button } from "antd";
import API from "API";
import Management from "components/general/Management";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

function UniversityTests() {
    const [courses, setCourses] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        API.get("courses/?search=&page=1&page_size=1000")
            .then((res) => {
                const optionCourses = res.data?.results.map(({ name, id }) => ({
                    label: name,
                    value: id,
                }));
                setCourses(optionCourses);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    const layout = [
        [
            {
                label: "Khóa học",
                name: "course",
                placeHolder: "Khóa học",
                type: "select",
                rules: [{ required: true, message: "Vui lòng chọn khóa học!" }],
                options: courses,
            },
        ],
        [
            {
                label: "Tên bài kiểm tra",
                name: "title",
                type: "input",
                placeHolder: "Bài kiểm tra số 1",
                rules: [
                    {
                        required: true,
                        message: "Vui lòng nhập tên bài kiểm tra!",
                    },
                ],
            },
        ],
        [
            {
                label: "Thời gian làm bài",
                name: "time",
                type: "inputNumber",
                rules: [
                    {
                        required: true,
                        message: "Vui lòng nhập thời gian làm bài",
                    },
                ],
                placeHolder: "0",
            },
        ],
    ];

    const columns = [
        { title: "Khóa học", dataIndex: "course_name", key: "course_name" },
        { title: "Tên bài kiểm tra", dataIndex: "title", key: "title" },
        { title: "Thời gian làm bài", dataIndex: "time", key: "time" },
        {
            title: "Ngày kiểm tra",
            dataIndex: "release",
            key: "release",
            render: (text, record) => {
                return (
                    <>
                        {record?.releases.map(({ start_time, end_time }) => (
                            <>
                                <Button style={{ margin: 1 }}>
                                    {dayjs(start_time).format(
                                        "DD/MM/YYYY HH:mm:ss"
                                    )}{" "}
                                    -{" "}
                                    {dayjs(end_time).format(
                                        "DD/MM/YYYY HH:mm:ss"
                                    )}
                                </Button>
                                <br />
                            </>
                        ))}
                    </>
                );
            },
        },
    ];

    return (
        <div>
            <h2>Quản lý bài kiểm tra</h2>
            <Management
                layout={layout}
                columns={columns}
                apiPath="/tests/"
                itemName="bài kiểm tra"
                listMode="table"
                useFrontendPagination={false}
                onTableClick={(item) => {
                    navigate(`/university-tests/${item.id}`);
                }}
                disableSearch={false}
            />
        </div>
    );
}

export default UniversityTests;
